(function (app, ng) {

    app.component("configureCaptureWorkflow",
        {
            controller: configureCaptureWorkflowController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Workflows/Capture/template.html",
            bindings: {
                transactionGroup: "=",
                capturePoints: "=",
                requiredCaptureDocuments: "=",
                publishedTransactionGroup: "<",
                publishedTransactionGroupQuestionCategories: "<",
                questionCategories: "=",
                stockQuestions: "=",
                onSave: "&"
            }
        });

    configureCaptureWorkflowController.$inject = ["questionApi", "transactionGroupApi", "$q", "_", "figToaster", "figToastContainers"];
    function configureCaptureWorkflowController(questionApi, transactionGroupApi, $q, _, figToaster, figToastContainers) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                addRequiredDocument: addRequiredDocument,
                removeRequiredDocument: removeRequiredDocument,
                updateTransactionGroup: updateTransactionGroup,
                checkValidName: checkValidName,
                addCategory: addCategory,
                addStockQuestion: addStockQuestion,
                updateCategory: updateCategory,
                addQuestion: addQuestion,
                updateQuestion: updateQuestion,
                removeQuestion: removeQuestion,
                removeCategory: removeCategory,
                addAnswer: addAnswer,
                dropCategory: dropCategory,
                dropQuestion: dropQuestion,
                categoryMoved: categoryMoved,
                questionMoved: questionMoved,
                setCapturePointActiveState: setCapturePointActiveState
            });

        this.$onInit = function () {
            $ctrl.typeLookup = [];
            $ctrl.typeLookup["SelectOne"] = "Select One";
            $ctrl.typeLookup["SelectMany"] = "Select Many";
            $ctrl.typeLookup["LongText"] = "Long Text";
            $ctrl.typeLookup["ShortText"] = "Short Text";

            $ctrl.selectedCapturePoint = $ctrl.capturePoints[0].Value;

            $ctrl.nextCategoryOrder = 1000;
            ng.forEach($ctrl.questionCategories,
                function (category) {
                    if (category.Order >= $ctrl.nextCategoryOrder)
                        $ctrl.nextCategoryOrder = category.Order + 1000;
                });
            checkUnpublishedChanges();
        };

        function setCapturePointActiveState(index) {
            $ctrl.capturePoints[index].Unpublished = !$ctrl.capturePoints[index].Unpublished;
            updateUnpublishedChanges($ctrl.capturePoints[index]);
            updateTransactionGroup();
        }

        function updateTransactionGroup() {
            $ctrl.transactionGroup.CapturePoints = [];
            ng.forEach($ctrl.capturePoints,
                function (capturePoint) {
                    if (capturePoint.IsActive)
                        $ctrl.transactionGroup.CapturePoints.push(capturePoint.Value);
                });

            $ctrl.transactionGroup.RequiredCaptureDocuments = [];
            ng.forEach($ctrl.requiredCaptureDocuments,
                function (document) {
                    $ctrl.transactionGroup.RequiredCaptureDocuments.push(document.Value);
                });

            if ($ctrl.transactionGroup.RequiredCaptureDocuments.length === 0 &&
                $ctrl.transactionGroup.CapturePoints.includes("NeededDocuments")) {
                var index = _.findIndex($ctrl.transactionGroup.CapturePoints,
                    function (capturePoint) {
                        return capturePoint === "NeededDocuments";
                    });

                $ctrl.transactionGroup.CapturePoints.splice(index, 1);
            }

            if (($ctrl.questionCategories.length === 0 || $ctrl.questionCategories[0].QuestionList.length === 0) &&
                $ctrl.transactionGroup.CapturePoints.includes("Questionnaire")) {
                var _index = _.findIndex($ctrl.transactionGroup.CapturePoints,
                    function (capturePoint) {
                        return capturePoint === "Questionnaire";
                    });

                $ctrl.transactionGroup.CapturePoints.splice(_index, 1);
            }

            transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
        };

        function addRequiredDocument() {
            $ctrl.requiredCaptureDocuments.push({ Value: $ctrl.UI.documentName, Unpublished: true });
            $ctrl.UI.documentName = "";
            $ctrl.transactionGroup.UnpublishedChanges++;
            updateTransactionGroup();
        }

        function removeRequiredDocument(document, index) {
            figToaster.showYesNo("Are you sure you would like to delete " + document.Value + "?",
                "bottom center",
                figToastContainers.get("configure-transaction-group"),
                true).then(function (response) {
                    if (!response) return;

                    $ctrl.transactionGroup.UnpublishedChanges++;
                    $ctrl.requiredCaptureDocuments.splice(index, 1);
                    updateTransactionGroup();
                });
        }

        function checkValidName(document) {
            if (document.NewName === "") {
                document.NewName = document.Name;
            } else {
                document.Value = document.NewName;
            }

            delete document.NewName;
        }

        function addCategory() {
            var category = {
                TransactionGroupId: $ctrl.transactionGroup.Id,
                Order: getNextCategoryOrder(),
                QuestionList: [],
                IsActive: true,
                Unpublished: true
            };
            $ctrl.transactionGroup.UnpublishedChanges++;
            $ctrl.questionCategories.push(category);
            questionApi.createQuestionCategory(category).then(function (response) {
                category.Id = response.Id;
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            });
        }

        function updateCategory(category) {
            category.stockQuestions = [];
            ng.forEach(category.QuestionList,
                function (q) {
                    if (q.StockQuestionId) {
                        category.stockQuestions
                            .push({ StockQuestionId: q.StockQuestionId, Required: q.Required, Order: q.Order });
                    }
                });

            category.Unpublished = true;
            $ctrl.transactionGroup.UnpublishedChanges++;
            questionApi.updateQuestionCategory(category).then(function () {
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            });
        }

        function addQuestion(category, index) {
            var question = {
                IsActive: true,
                Required: false,
                Minimized: false,
                PossibleAnswers: [],
                StockQuestionId: null,
                CategoryId: category.Id,
                Type: $ctrl.selectedQuestionType,
                Order: getNextQuestionOrder(index),
                Unpublished: true
            }
            $ctrl.transactionGroup.UnpublishedChanges++;
            $ctrl.questionCategories[index].QuestionList.push(question);
            questionApi.createQuestion(question).then(function (response) {
                question.Id = response.Id;
                $ctrl.selectedQuestionType = null;
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            });
        }

        function addStockQuestion(category, index) {
            var question = {
                IsActive: true,
                Required: false,
                Minimized: false,
                CategoryId: category.Id,
                Type: $ctrl.selectedQuestionType,
                Order: getNextQuestionOrder(index),
                StockQuestionId: $ctrl.selectedStockQuestion.Id,
                QuestionText: $ctrl.selectedStockQuestion.QuestionText,
                PossibleAnswers: $ctrl.selectedStockQuestion.PossibleAnswers,
                Unpublished: true
            }
            $ctrl.transactionGroup.UnpublishedChanges++;
            $ctrl.questionCategories[index].QuestionList.push(question);
            category.StockQuestions = [];
            $ctrl.selectedStockQuestion = null;
            ng.forEach(category.QuestionList, function (q) {
                if (q.StockQuestionId) {
                    category.StockQuestions.push({ StockQuestionId: q.StockQuestionId, Required: q.Required, Order: q.Order });
                }
            });
            questionApi.updateQuestionCategory(category).then(function () {
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            });
        }

        function updateQuestion(question, category) {
            if (!question.Unpublished)
                $ctrl.transactionGroup.UnpublishedChanges++;

            question.Unpublished = true;
            if (question.StockQuestionId) {
                category.StockQuestions = [];
                ng.forEach(category.QuestionList,
                    function (q) {
                        if (q.StockQuestionId) {
                            category.StockQuestions.push({
                                StockQuestionId: q.StockQuestionId,
                                Required: q.Required,
                                Order: q.Order
                            });
                        }
                    });
                questionApi.updateQuestionCategory(category).then(function () {
                    transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
                });
            } else {
                questionApi.updateQuestion(question);
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            }
        }

        function removeQuestion(question, category) {
            figToaster.showYesNo("Are you sure you would like to delete " +
                (question.QuestionText ? question.QuestionText : "this question") +
                "?",
                "bottom center",
                figToastContainers.get("configure-transaction-group"),
                true).then(function (response) {
                    if (!response) return;

                    $ctrl.transactionGroup.UnpublishedChanges++;
                    question.IsActive = false;
                    if (question.StockQuestionId) {
                        category.StockQuestions = [];
                        ng.forEach(category.QuestionList,
                            function (q) {
                                if (q.StockQuestionId && q.IsActive) {
                                    category.StockQuestions.push({
                                        StockQuestionId: q.StockQuestionId,
                                        Required: q.Required,
                                        Order: q.Order
                                    });
                                }
                            });
                        questionApi.updateQuestionCategory(category).then(function () {
                            transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
                        });
                    } else {
                        $ctrl.updateQuestion(question);
                        transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
                    }
                });
        }

        function removeCategory(category) {
            figToaster.showYesNo("Are you sure you would like to delete " +
                (category.Name ? category.Name : "this category") +
                "?",
                "bottom center",
                figToastContainers.get("configure-transaction-group"),
                true).then(function (response) {
                    if (!response) return;

                    $ctrl.transactionGroup.UnpublishedChanges++;
                    category.IsActive = false;
                    $ctrl.updateCategory(category);
                    transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
                });
        }

        function addAnswer(question) {
            if ($ctrl.newPossibleAnswer !== "") {
                question.Unpublished = true;
                $ctrl.transactionGroup.UnpublishedChanges++;
                question.PossibleAnswers.push({ Value: $ctrl.newPossibleAnswer, CanHaveExplination: false });
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            }
            $ctrl.newPossibleAnswer = "";
        }

        function dropCategory(event, index, item) {
            if (index === 0) {
                var nextCategory = $ctrl.questionCategories[0];
                var ind = _.findIndex($ctrl.questionCategories, function (row) {
                    return row.Id === nextCategory.Id;
                });
                $ctrl.questionCategories.splice(ind, 0, item);
            } else {
                var prevCategory = $ctrl.questionCategories[index - 1];
                var ind2 = _.findIndex($ctrl.questionCategories, function (row) {
                    return row.Id === prevCategory.Id;
                });
                $ctrl.questionCategories.splice(ind2 + 1, 0, item);
            }
            return true;
        }

        function dropQuestion(event, index, item, cIndex) {
            if (index === 0) {
                var nextQuestion = $ctrl.questionCategories[cIndex].QuestionList[0];
                var ind = _.findIndex($ctrl.questionCategories[cIndex].QuestionList,
                    function (row) {
                        return row.Id === nextQuestion.Id;
                    });
                $ctrl.questionCategories[cIndex].QuestionList.splice(ind, 0, item);
            } else {
                var prevQuestion = $ctrl.questionCategories[cIndex].QuestionList[index - 1];
                var ind2 = _.findIndex($ctrl.questionCategories[cIndex].QuestionList,
                    function (row) {
                        return row.Id === prevQuestion.Id;
                    });
                $ctrl.questionCategories[cIndex].QuestionList.splice(ind2 + 1, 0, item);
            }
            return true;
        }

        function categoryMoved(category) {
            var index = _.findIndex($ctrl.questionCategories, function (row) {
                return row.$$hashKey === category.$$hashKey
            });
            $ctrl.questionCategories.splice(index, 1);

            for (var i = 0; i < $ctrl.questionCategories.length; i++) {
                if ($ctrl.questionCategories[i].Id === category.Id)
                    $ctrl.questionCategories[i].Order = $ctrl.questionCategories[i + 1].Order / 2;
                else if (i === $ctrl.questionCategories.length - 1)
                    $ctrl.questionCategories[i].Order = $ctrl.questionCategories[i - 1].Order + 1000;
                else
                    $ctrl.questionCategories[i].Order = ($ctrl.questionCategories[i - 1].Order +
                        $ctrl.questionCategories[i + 2].Order) /
                        2;
            }
            category.Unpublished = true;
            $ctrl.transactionGroup.UnpublishedChanges++;
            ng.forEach($ctrl.questionCategories,
                function (category) {
                    $ctrl.updateCategory(category);
                });
            transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
        };

        function questionMoved(questionList, question) {
            var index = _.findIndex(questionList, function (row) {
                return row.$$hashKey === question.$$hashKey;
            });
            questionList.splice(index, 1);

            for (var i = 0; i < questionList.length; i++) {
                if (questionList[i].Id === question.Id) {
                    if (i === 0)
                        questionList[i].Order = questionList[i + 1].Order / 2;
                    else if (i === questionList.length - 1)
                        questionList.Order = questionList[i - 1].Order + 1000;
                    else
                        questionList[i].Order = (questionList[i - 1].Order + questionList[i + 1].Order) / 2;
                }
            }
            
            ng.forEach(questionList,
                function (question) {
                    question.Unpublished = true;
                    $ctrl.transactionGroup.UnpublishedChanges++;
                    $ctrl.updateQuestion(question);
                    transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
                });
        };

        function getNextCategoryOrder() {
            var prevOrder = $ctrl.nextCategoryOrder;
            $ctrl.nextCategoryOrder = $ctrl.nextCategoryOrder + 1000;
            return prevOrder;
        }

        function getNextQuestionOrder(categoryIndex) {
            var nextQuestionOrder = 1000;
            ng.forEach($ctrl.questionCategories[categoryIndex].QuestionList,
                function (q) {
                    if (q.Order >= nextQuestionOrder)
                        nextQuestionOrder = q.Order + 1000;

                });
            return nextQuestionOrder;
        }

        function updateUnpublishedChanges(item) {
            if (item.Unpublished === true)
                $ctrl.transactionGroup.UnpublishedChanges++;
            else
                $ctrl.transactionGroup.UnpublishedChanges--;
        }

        function checkUnpublishedChanges() {
            if ($ctrl.publishedTransactionGroup && $ctrl.transactionGroup) {

                ng.forEach($ctrl.transactionGroup.CapturePoints, function (point) {
                    if (!_.find($ctrl.publishedTransactionGroup.CapturePoints, function (p) {
                        return p === point;
                    })) {
                        _.find($ctrl.capturePoints, function (p) {
                            return p.Value === point;
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.publishedTransactionGroup.CapturePoints, function (point) {
                    if (!_.find($ctrl.transactionGroup.CapturePoints, function (p) {
                        return p === point;
                    })) {
                        _.find($ctrl.capturePoints, function (p) {
                            return p.Value === point;
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.transactionGroup.RequiredCaptureDocuments, function (doc) {
                    if (!_.find($ctrl.publishedTransactionGroup.RequiredCaptureDocuments, function (d) {
                        return d === doc;
                    })) {
                        _.find($ctrl.requiredCaptureDocuments, function (d) {
                            return d.Value === doc;
                        }).Unpublished = true;
                    }
                });

                ng.forEach($ctrl.questionCategories, function (cat) {
                    if (!_.find($ctrl.publishedTransactionGroupQuestionCategories, function (q) {
                        return q.Name === cat.Name;
                    })) {
                        cat.Unpublished = true;
                    }

                    ng.forEach(cat.QuestionList, function (item) {
                        var tmpCategory = _.find($ctrl.publishedTransactionGroupQuestionCategories, function (c) {
                            return cat.Id === c.Id;
                        });

                        if (tmpCategory.QuestionList) {
                            if (!_.find(tmpCategory.QuestionList, function (question) {
                                return question.QuestionText === item.QuestionText;
                            })) {
                                item.Unpublished = true;
                            }
                        }
                    });
                });
            } else {
                ng.forEach($ctrl.capturePoints, function (point) {
                    if (point.IsActive)
                        point.Unpublished = true;
                });

                ng.forEach($ctrl.transactionGroup.RequiredCaptureDocuments, function (doc) {
                    doc.Unpublished = true;
                });

                ng.forEach($ctrl.questionCategories, function (cat) {
                    cat.Unpublished = true;
                    ng.forEach(cat.QuestionList, function (item) {
                        item.Unpublished = true;
                    });
                });
            }
        }
    };

})(window.app, window.angular); // jshint ignore:line